import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  signal,
} from "@angular/core";
import {
  UntypedFormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { marker as TRANSLATE_ME } from "@biesbjerg/ngx-translate-extract-marker";
import { CrudService } from "../../Services/crud.service";
import { LogedInUserService } from "../../Services/loged-in-user.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {
  ModalDismissReasons,
  NgbAccordionConfig,
  NgbModal,
  NgbNavChangeEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { HistoryModuleComponent } from "./history-module/history-module.component";
import { MatDialog } from "@angular/material/dialog";
import { LoadingService } from "src/app/Services/loading.service";
import { GenerateAiContentComponent } from "src/app/Modals/generate-ai-content/generate-ai-content.component";
import { DeleteConfirmationDialogComponent } from "../delete-confirmation-dialog/delete-confirmation-dialog.component";
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: "app-screen-detail-edit",
  templateUrl: "./screen-detail-edit.component.html",
  standalone: false,
  styles: [
    `
      :host {
        font-weight: 500;
      }

      .accordion .accordion-item {
        border: none;
        border-radius: 12px;
        background-color: transparent;
        margin-bottom: 1rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* optional subtle shadow */
      }

      .accordion-button {
        background-color: transparent;
        font-weight: 500;
        color: #032d55; /* Your preferred text color */
        box-shadow: none;
        text-decoration: none;
        border: none;
        border-radius: 12px;
      }

      .accordion-button:focus {
        box-shadow: none;
        outline: none;
      }

      .accordion-button::after {
        transform: rotate(90deg); /* Optional: rotate arrow to the right */
      }

      .accordion-button:not(.collapsed) {
        box-shadow: none !important;
        border-bottom: none !important;
      }

      h5 {
        background-color: transparent;
      }
      .accordion-header {
        border: 1px;
        background-color: transparent !important;
      }
      .accordion-class {
        border: none !important;
      }
      .accordion-class .btn {
        color: #032d55 !important;
        background-color: transparent !important;
        box-shadow: none !important;
      }

      h2 {
        border: 1px solid #fff;
      }
      li.nav-item .nav-link._tas-tabs {
        color: #032d55 !important;
      }

      li.nav-item .nav-link._tas-tabs.active {
        background-color: #032d55 !important;
        color: #f5f7fa !important;
        border-radius: 20px;
      }

      .no-after-icon::after {
        display: none !important;
      }

      ::ng-deep .custom-width-modal .modal-dialog {
        width: 50vw;
        max-width: none;
 
 
      .tab-content {
        overflow: auto; /* Enable vertical scrolling */
      }
    `,
  ],
})
export class ScreenDetailEditComponent implements OnInit {
  currentProject = {
    id: "",
    name: "",
    primaryLanguage: "",
    supportedLanguage: [],
  };
  isLanguageChanged: boolean = false;
  languageId: any = "";
  commonObject: any = {};

  translatedValuesMap: { [id: string]: any } = {};
  languageChangeTooltip = "";
  clickedElement: any = "";
  isOpen: boolean = false;
  currentScreen = { id: "", name: "" };
  tooltips = [];
  workflows = [];
  faqThumbsUp: { [key: string]: number } = {};
  faqThumbsDown: { [key: string]: number } = {};
  faq = [];
  globalConfig;
  newFaq = "new";
  userguide = [];
  activeTabId = "tooltip-tab-id";
  selectedTooltipLanguage = {};
  selectedFAQLanguage = {};
  selectedUserGuideLanguage = {};
  languageList = [];
  versionList = [];
  addFAQ = false;
  addUserGuide = false;
  defaultWorkflow;
  selectedEnv = "dev";
  selectedVersion;
  enviornment = [];
  isLoading = false;
  defaultTemplate;
  formGroup;
  projectId: any = "";
  screenId: any = "";
  roles: any = [];
  closeResult;
  modalref;
  isAddTooltip: boolean = false;
  isAddWorkflow: boolean = false;
  selectedLanguage: any = "";
  private loadingSub: any;
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    config: NgbAccordionConfig,
    private modalService: NgbModal,
    private router: Router,
    private dialog: MatDialog,
    private loadingService: LoadingService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    this.enviornment = [
      { label: "Dev", value: "dev" },
      { label: "QA", value: "qa" },
      { label: "Prod", value: "prod" },
    ];
  }
  dataSignal = signal<string>("");

  @ViewChildren("accordion") accordions!: QueryList<any>;
  @ViewChild("languageSelect") languageSelect!: NgSelectComponent;

  languages = [
    {
      label: "Primary Language",
      items: [
        {
          id: this.currentProject.primaryLanguage,
          name: this.getLanguageName(this.currentProject.primaryLanguage),
        },
      ],
    },
    {
      label: "Secondary Languages",
      items: this.currentProject.supportedLanguage,
    },
  ];
  async ngOnInit() {
    const treeData = [
      {
        id: 1,
        name: "Root",
        children: [
          {
            id: 2,
            name: "Child 1",
            children: [
              { id: 5, name: "Child 1.1" },
              { id: 6, name: "Child 1.2" },
            ],
          },
          {
            id: 3,
            name: "Child 2",
            children: [
              { id: 7, name: "Child 2.1" },
              { id: 8, name: "Child 2.2" },
            ],
          },
          {
            id: 4,
            name: "Child 3",
          },
        ],
      },
    ];
    this.projectId = this.route.snapshot.paramMap.get("pid");
    this.screenId = this.route.snapshot.paramMap.get("sid");

    this.activeTabId = "tooltip-tab-id";

    this.loadingService.show();
    this.route.params.subscribe((params) => {
      let projectId = params["pid"];
      let screenId = params["sid"];
      this.activeTabId =
        params["tabId"] == "tooltips"
          ? "tooltip-tab-id"
          : params["tabId"] == "faqs"
          ? "faq-tab-id"
          : params["tabId"] == "userguide"
          ? "user-guide-tab-id"
          : params["tabId"] == "workflows"
          ? "workflow-tab-id"
          : this.activeTabId;
      this.getVersions(projectId);
      this.getLatestVersion(projectId);
      this.getProjectManagementData = this.getProjectManagementData.bind(this);
      this.getScreenManagement = this.getScreenManagement.bind(this);
      this.getTooltips = this.getTooltips.bind(this);
      this.getFAQ = this.getFAQ.bind(this);
      this.getUserGuide = this.getUserGuide.bind(this);
      this.getGlobalConfig(projectId);
      this.getLanguages();
      this.fetchGlobalConfig(projectId);

      this.getProjectManagementData(projectId);

      setTimeout(() => {
        this.getScreenManagement(screenId, projectId);
        this.getAppRoles();
        this.loadingService.hide();
      }, 1500);
    });

    // this.isLoading = true;
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });
  }
  ngAfterViewInit() {
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        const el = document.getElementById(fragment);
        if (el) {
          // Smooth scroll to the element
          el.scrollIntoView({ behavior: "smooth", block: "start" });

          // Try to find associated accordion and open it
          const acc = this.accordions.find(
            (acc) => acc._elementRef.nativeElement.id === fragment
          );
          if (acc) {
            const toggle = el.querySelector("[ngbAccordionButton]");
            if (toggle) {
              (toggle as HTMLElement).click(); // Open the matched accordion
            }
          }
        }
      }
    });
  }

  calculateFAQUsageAnalytics() {
    this.faq.forEach((f) => {
      this.getUsageAnalyticThumbsUpCount(f.id);
      this.getUsageAnalyticThumbsDownCount(f.id);
    });
  }

  calculateWorkflowUsageAnalytics() {
    this.workflows.forEach((f) => {
      this.getUsageAnalyticThumbsUpCount(f.id);
      this.getUsageAnalyticThumbsDownCount(f.id);
    });
  }

  calculateUGUsageAnalytics() {
    this.userguide.forEach((f) => {
      this.getUsageAnalyticThumbsUpCount(f.id);
      this.getUsageAnalyticThumbsDownCount(f.id);
    });
  }

  getGlobalConfig(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response, req) {
        if (!response.status) {
          self.globalConfig = response;
          self.addGlobalCSS();
        }
      },
      'globalConfigs/findOne?filter={"where":{"projectManagementId":"' +
        projectId +
        '"}}'
    );
  }
  addGlobalCSS() {
    if (this.globalConfig.userGuideClasses) {
      let userGuideClasses = this.globalConfig.userGuideClasses;

      // Ensure that userGuideContent has a unique identifier
      let contentId =
        "faq-editor1 .angular-editor .angular-editor-wrapper .angular-editor-textarea"; // Replace this with the actual ID or class of your element

      // Scope the CSS rules to the userGuideContent element
      let scopedCss = userGuideClasses.replace(
        /([^\}]+)\{/g,
        function (match, selector) {
          // Add the scope only to valid CSS selectors, ignore if already scoped
          return `#${contentId} ${selector.trim()} {`;
        }
      );

      // Create a new <style> element
      let styleElement = document.createElement("style");
      styleElement.type = "text/css";

      // Add the scoped CSS to the <style> element
      styleElement.appendChild(document.createTextNode(scopedCss));

      // Append the <style> element to the document's head
      document.head.appendChild(styleElement);
    }
  }

  getLanguages() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.languageList = response;
      },
      "languages"
    );
  }

  fetchGlobalConfig(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        if (response && response.defaultTemplate) {
          self.defaultTemplate = response.defaultTemplate;
        } else {
          self.defaultTemplate = null;
        }
      },
      'globalConfigs/findOne?filter={"where":{"projectManagementId":"' +
        projectId +
        '"}}'
    );
  }

  getVersions(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.versionList = response;
      },
      "Versions?filter[order]=created DESC&filter[where][projectManagementId]=" +
        projectId
    );
  }

  getLatestVersion(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.selectedVersion = response.id;
      },
      "Versions/findOne?filter[order]=created DESC&filter[where][projectManagementId]=" +
        projectId
    );
  }

  getProjectManagementData(projectId) {
    this.crudService.get(
      null,
      (response) => {
        this.currentProject = response;
        this.selectedLanguage = this.currentProject["primaryLanguage"];
      },
      'projectManagements/findOne?filter={"where":{"id":"' + projectId + '"}}'
    );
  }

  getScreenManagement(screenId, projectId) {
    this.isLoading = false;
    let self = this;
    self.logedInUserService.get(function (logedInUser) {
      self.crudService.get(
        null,
        function (response) {
          if (response) {
            self.currentScreen = response;

            self.defaultWorkflow = self.currentScreen["defaultWorkflow"];
            self.getTooltips(self.currentScreen.id);
            self.getFAQ(self.currentScreen.id);
            self.getUserGuide(self.currentScreen.id);
            self.getWorkflowsCount(self.currentScreen.id);
          }
        },
        'screenManagements/findOne?filter={"where":{"id":"' + screenId + '"}}'
      );
    });
  }
  getTooltips(screenManagementId) {
    // console.log("version", self.selectedVersion);
    let query = `screenManagementId=${screenManagementId}&languageId=${this.currentProject.primaryLanguage}&publishStage=${this.selectedEnv}&projectVersion=${this.selectedVersion}`;

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length) {
          this.tooltips = response;
          /*  this.tooltips = this.tooltips.map(
            (item) => item.languageId == this.currentProject.primaryLanguage
          ); */
        } else {
          this.tooltips = [];
        }
      },
      "tooltips/getTooltipsForWebAndPlugin?" + query
    );
  }

  getFAQ(screenManagementId) {
    this.loadingService.show();
    let query = `screenManagementId=${screenManagementId}&languageId=${this.currentProject.primaryLanguage}&publishStage=${this.selectedEnv}&projectVersion=${this.selectedVersion}`;
    this.crudService.get(
      null,
      (response: any) => {
        if (response) {
          this.faq = response;

          this.loadingService.hide();
          this.calculateFAQUsageAnalytics();
        } else {
          this.faq = [];
        }
      },
      "faqs/getFaqsForWebAndPlugin?" + query
    );
  }

  getUserGuide(screenManagementId) {
    let self = this;
    let query = `screenManagementId=${screenManagementId}&languageId=${self.currentProject.primaryLanguage}&publishStage=${self.selectedEnv}&projectVersion=${self.selectedVersion}`;

    this.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.userguide = response;
          // console.log("self userguide", self.userguide);
          self.calculateUGUsageAnalytics();
        } else {
          self.userguide = [];
        }
      },
      "userGuides/getUserGuidesForWebAndPlugin?" + query
    );
  }
  onfilterChange(e) {
    // console.log(e);
    this.selectedEnv = e;
    this.getTooltips(this.currentScreen.id);
    this.getFAQ(this.currentScreen.id);
    this.getUserGuide(this.currentScreen.id);
    this.getWorkflowsCount(this.currentScreen.id);
    this.getAppRoles();
  }

  onVersionfilterChange(e) {
    // console.log(e);
    this.selectedVersion = e;
    this.getTooltips(this.currentScreen.id);
    this.getFAQ(this.currentScreen.id);
    this.getUserGuide(this.currentScreen.id);
    this.getWorkflowsCount(this.currentScreen.id);
    this.getAppRoles();
  }

  getAppRoles() {
    let self = this;
    const filter = {
      where: {
        version: self.selectedVersion,
        projectManagementId: self.currentProject.id,
      },
    };
    const encodedFilter = encodeURIComponent(JSON.stringify(filter));
    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.roles = response;
        } else {
          self.roles = [];
        }
      },
      `appRoles?filter=${encodedFilter}`
    );
  }
  getWorkflowsCount(screenManagementId) {
    // this.isLoading = true;
    let self = this;
    console.log(
      "screenmanagement id",
      screenManagementId,
      "selectedEnv",
      this.selectedEnv,
      "selectedVersion",
      this.selectedVersion,
      "projectmanagementid",
      this.currentProject.id
    );
    let query = `screenManagementId=${screenManagementId}&publishStage=${self.selectedEnv}&projectVersion=${self.selectedVersion}&projectManagementId=${this.currentProject.id}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.workflows = response;
          self.isLoading = false;
          self.calculateWorkflowUsageAnalytics();
        } else {
          self.workflows = [];
        }
      },
      "workflows/getWorkflowsForWebAndPlugin?" + query
    );
  }

  openScreenDetailEditView(screenId) {
    this.router.navigate(["/page/project-detail-edit", screenId, screenId]);
  }

  public onSelectedTooltipLanguageChange(data: any): void {
    this.selectedTooltipLanguage[data.id] = data.name;
  }

  getSelectedTooltipLanguage(tooltipId) {
    return this.selectedTooltipLanguage[tooltipId];
  }

  public onSelectedFAQLanguageChange(data: any): void {
    this.selectedFAQLanguage[data.id] = data.name;
  }

  getSelectedFAQLanguage(faqId) {
    return this.selectedFAQLanguage[faqId];
  }

  public onSelectedUserGuideLanguageChange(data: any): void {
    this.selectedUserGuideLanguage[data.id] = data.name;
  }

  getSelectedUserGuideLanguage(userGuideId) {
    return this.selectedUserGuideLanguage[userGuideId];
  }

  getLanguageName(languageId) {
    if (this.languageList.length) {
      var langauge = this.languageList.find(function (val) {
        return val.id === languageId;
      });
      if (langauge) {
        return langauge.name;
      } else {
        return "English";
      }
    }
  }

  getTooltipHistory(tooltipId, type) {
    let self = this;
    var modalRef;
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          this.modalref = this.modalService.open(HistoryModuleComponent, {
            backdrop: "static",
            windowClass: "top-modal custom-width-modal",
          });
          this.modalref.componentInstance.data.response = response;
          this.modalref.componentInstance.data.type = type;

          /*  modalRef.result
          .then((result) => {
            if (result) {}) */
        }
      },
      /*    ,
      function (response) {
        if (response) {
          self.dialog.open(HistoryModuleComponent, {
            width: "600px",
            panelClass: "custom-popup-history",
            data: { response: response, type: type },
          });
        }
      }, */
      `tooltipDetails?filter[order]=updatedAt DESC&filter[where][tooltipId]=${tooltipId}`
    );
  }

  getFAQHistory(faqId, type) {
    let self = this;

    this.crudService.get(
      null,
      function (response) {
        if (response) {
          /*  const modalref = this.modalService.open(HistoryModuleComponent, {
            width: "600px",
            panelClass: "custom-popup-history",
            data: { response: response, type: type },
          });
          */
        }
      },
      `faqDetails?filter[order]=updatedAt DESC&filter[where][faqId]=${faqId}&filter[where][publishStage]=${self.selectedEnv}&filter[where][projectVersion]=${self.selectedVersion}&filter[where][languageId]=${self.currentProject.primaryLanguage}`
    );
  }
  getUserGuideHistory(userGuideId, type) {
    let self = this;

    this.crudService.get(
      null,
      function (response) {
        if (response) {
          self.dialog.open(HistoryModuleComponent, {
            width: "600px",
            panelClass: "custom-popup-history",
            data: { response: response, type: type },
          });
        }
      },
      `userGuideDetails?filter[order]=updatedAt DESC&filter[where][userGuideId]=${userGuideId}&filter[where][publishStage]=${self.selectedEnv}&filter[where][projectVersion]=${self.selectedVersion}&filter[where][languageId]=${self.currentProject.primaryLanguage}`
    );
  }
  getWorkflowHistory(workflowId, type) {
    let self = this;

    this.crudService.get(
      null,
      function (response) {
        if (response) {
          self.dialog.open(HistoryModuleComponent, {
            width: "600px",
            panelClass: "custom-popup-history",
            data: { response: response, type: type },
          });
        }
      },
      `workflowDetails?filter[order]=updatedAt DESC&filter[where][workflowId]=${workflowId}&filter[where][publishStage]=${self.selectedEnv}&filter[where][projectVersion]=${self.selectedVersion}`
    );
  }

  saveDefaultWorkflow() {
    var self = this;
    self.currentScreen["defaultWorkflow"] = self.defaultWorkflow;
    self.crudService.update(
      self.currentScreen,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.toastr.success(
            "Default Workflow has been updated successfully.",
            "Success"
          );
        }
      },
      "screenManagements"
    );
  }

  getUsageAnalyticThumbsUpCount(id) {
    let query = `filter[where][refDetailsId]=${id}&filter[where][thumbsUp]=true`;

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length) {
          this.faqThumbsUp[id] = response.length;
        } else {
          this.faqThumbsUp[id] = 0;
        }
      },
      "feedbacks?" + query
    );
  }

  getUsageAnalyticThumbsDownCount(id) {
    let query = `filter[where][refDetailsId]=${id}&filter[where][thumbsDown]=true`;

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length) {
          this.faqThumbsDown[id] = response.length;
        } else {
          this.faqThumbsDown[id] = 0;
        }
      },
      "feedbacks?" + query
    );
  }

  addTooltipVisible(conditionTooltip) {
    this.isAddTooltip = conditionTooltip;
  }

  addWorkflowVisible(conditionWorkflow) {
    this.isAddWorkflow = conditionWorkflow;
  }
  addFAQVisible(condition) {
    this.addFAQ = condition;
  }

  addUserGuideVisible(condition) {
    this.addUserGuide = condition;
  }

  onTabChange(event: NgbNavChangeEvent) {
    const newTabId = event.nextId;

    // Map nav ID to route segment
    const tabMap: Record<string, string> = {
      "tooltip-tab-id": "tooltips",
      "faq-tab-id": "faqs",
      "user-guide-tab-id": "userguide",
      "workflow-tab-id": "workflows",
    };

    const tabRoute = tabMap[newTabId] || "tooltips"; // fallback

    this.router.navigate(
      [
        "/page/project-detail-edit",
        this.projectId,
        "screens",
        this.screenId,
        tabRoute,
      ],
      {
        queryParamsHandling: "preserve",
      }
    );
  }
  async addLogstoFile(xhr, extrainfo) {
    var data = {};

    if (xhr.responseText) {
      data["error"] = xhr.responseText;
    } else {
      data["error"] = xhr;
    }
    data["extraInfo"] = extrainfo;
    var payload = data;
    this.crudService.update(
      payload,
      function (response) {},
      "logErrors/addErrorToFile"
    );
  }

  onFormSubmitted() {
    this.addTooltipVisible(false);
    this.addFAQVisible(false);
    this.addWorkflowVisible(false);
    this.addUserGuideVisible(false);
    this.getScreenManagement(this.currentScreen.id, this.currentProject.id);
  }

  openCustomPromptWindow() {
    const modalref = this.modalService.open(GenerateAiContentComponent, {
      backdrop: "static",
      windowClass: "top-modal custom-width-modal",
    });

    modalref.componentInstance.title = "FAQs";
    modalref.componentInstance.prompt = `Based on the information below, generate a list of frequently asked questions (FAQs) along with their answers.
     The questions should help users understand the purpose, functionality, and usage of the screen in the context of the overall project.
     Project Name: ${this.currentProject.name}
        Project Description: ${this.currentProject["description"]}
        Screen Name: ${this.currentScreen.name}
        Screen Description: ${
          this.currentScreen["description"] != undefined &&
          this.currentScreen["description"] != null &&
          this.currentScreen["description"]?.trim() != ""
            ? this.currentScreen["description"]
            : ""
        }`;
    modalref.componentInstance.currentScreen = this.currentScreen;
    modalref.componentInstance.selectedVersion = this.selectedVersion;
    modalref.componentInstance.currentProject = this.currentProject;
    modalref.componentInstance.projectId = this.projectId;
    modalref.componentInstance.screenId = this.screenId;
    modalref.componentInstance.contentResponseforFAQ.subscribe((response) => {
      if (response && response.success == true) {
        this.getFAQ(this.screenId);
      }
    });
    modalref.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }

  recieveResfromWF(val) {
    this.isLoading = val;
  }

  /* used when deleting any item */
  deleteItem(item, itemType) {
    if (itemType == "faq") {
      const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
        width: "600px",
        panelClass: "custom-bg",
        data: {
          title: this.translateService.instant("Form.DeleteFAQ"),
          paragraph: this.translateService.instant("Form.DeleteFAQMsg"),
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadingService.show();

          this.crudService.delete(
            null,
            () => {
              this.crudService.delete(
                null,
                () => {
                  this.ngOnInit();
                },
                "currentFaqDetails/" + item["id"]
              );
            },
            "faq/" + item["faqId"]
          );
        }
      });
    } else if (itemType == "tooltip") {
      const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
        width: "600px",
        panelClass: "custom-bg",
        data: {
          title: this.translateService.instant("Form.DeleteTooltip"),
          paragraph: this.translateService.instant("Form.DeletetltpMsg"),
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadingService.show();

          this.crudService.delete(
            null,
            () => {
              this.ngOnInit();
            },
            "currentTooltipDetails/" + item["id"]
          );
        }
      });
    } else if (itemType == "workflow") {
      const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
        width: "600px",
        panelClass: "custom-bg",
        data: {
          title: this.translateService.instant("Form.DeleteWF"),
          paragraph: this.translateService.instant("Form.DeleteWFMsg"),
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadingService.show();
          this.crudService.delete(
            null,
            () => {
              this.crudService.delete(
                null,
                () => {
                  this.ngOnInit();
                },
                "currentWorkflowsDetails/" + item["id"]
              );
            },
            `currentWorkflowDetailsSteps/deleteFromWorkflowId?workflowsId=${item["id"]}`
          );
        }
      });
    }
  }

  /* adding hash in the individual item.id in the url */
  setHashAndToggle(
    elementId: string,
    accordionRef?: any,
    panelId: string = "ngb-panel-0"
  ) {
    this.router.navigate([], {
      fragment: elementId,
      queryParamsHandling: "preserve",
    });

    if (accordionRef) {
      accordionRef.toggle(panelId);
    }

    this.clickedElement = elementId;
  }
  onLanguageChange(value) {}
  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  /*function is called when we change the langugage from individual accordion
  function specification value: selected Language id, individualItem: selected item's id, type: type of item i.e. tooltip, workflow, faq, userguide */
  onChangeLanguage(value: any, individualItem, type) {
    this.selectedLanguage = value;
    this.isLanguageChanged = true;
    this.dataSignal = signal(this.selectedLanguage);
    if (type == "faq") {
      this.faq = this.faq.map((item) => {
        if (value !== item.languageId) {
          const matchedLang = item.supportedLanguages?.find(
            (lang) => lang.id === value
          );

          this.translatedValuesMap[individualItem] = {
            question: matchedLang?.question || "",
            answer: matchedLang?.answer || "",
          };
        } else {
          this.translatedValuesMap[individualItem] = {
            question: item?.question || "",
            answer: item?.answer || "",
          };
        }
        return item;
      });
    } else if (type == "tooltip") {
      const filter = {
        where: {
          languageId: this.selectedLanguage,
          publishStage: this.selectedEnv,
          projectVersion: this.selectedVersion,
          tooltipId: individualItem.tooltipId,
        },
      };

      this.crudService.get(
        null,
        (response) => {
          if (response != undefined && response != null) {
            this.languageChangeTooltip = response;
          }
        },
        `currentTooltipDetails/findOne?filter=${encodeURIComponent(
          JSON.stringify(filter)
        )}`
      );
    } else if (type == "workflow") {
      this.commonObject = {
        type: type,
        individualItem: individualItem,
        languageId: value,
      };
    } else {
    }
  }
  onPanelChange(somethingChanged) {}
}
